(ns url.linkedin
  "LinkedIn URL patterns and pure matching functions.
   Shared across platform and browser-extension."
  (:require [clojure.string :as str]))

(def person-url-pattern
  ;; Your custom URL must contain 3-100 letters or numbers. Please do not use spaces, symbols, or special characters."
  ;; https://www.linkedin.com/help/linkedin/answer/a542685/customizing-your-public-profile-url?lang=en
  #"(linkedin\.com/in/[^/^?]+).*$")

(def recruiter-person-url-pattern
  #"(linkedin\.com/talent/hire/[0-9]+/[A-Za-z0-9/]+/profile/[^?]*)")

(def company-url-pattern
  #"(linkedin\.com/company/[^/^?]+)")

(def li-person-label-id
  "LinkedIn derived values that can be used for magic fill"
  [["Full Name" :li.person/name]
   ["Headline" :li.person/headline]
   ["Location" :li.person/location]
   ["Current Job Title" :li.person/current-title]
   ["Current Company" :li.person/current-company]
   ["Degree" :li.person/degree]
   ["School" :li.person/education]
   ["Start Year" :li.person/job-start-year]
   ["LinkedIn Profile URL" :li.person/public-profile]])

(defn is-profile?
  "Returns truthy if the given URL is a LinkedIn profile page."
  [url]
  (if (string? url)
    (or (str/includes? url "linkedin.com/in/")
        ;; example urls:
        ;; https://www.linkedin.com/talent/hire/1233096993/discover/recruiterSearch/profile/abc?foo
        ;; https://www.linkedin.com/talent/hire/1233096993/discover/automatedSourcing/review/profile/abc?foo
        ;; www.linkedin.com/talent/hire/1304419921/manage/all/profile/abc?foo
        ;; there could be more, so use a regex, assuming they'll all end in /profile/{profile_id} and ignore query params
        (re-find recruiter-person-url-pattern url))
    false))

(defn is-company?
  "Returns true if the given URL is not a LinkedIn profile (i.e. a company page)."
  [url]
  (not (is-profile? url)))
